<a class="skip-to-main-content" [href]="appService.currentUrl+'#maincontent'"
   *ngIf="!(appService.loading$ | async)"
   [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? '' : null">Skip to Main Content</a>

<div class="app-container" [attr.aria-busy]="(appService.loading$ | async) ? 'true' : 'false'"
    [ngClass]="{
        'app-container--rail': appService.railPage
    }"
    [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? '' : null">
    <app-header [helpOpened]="helpSidenav?.opened" (toggleHelp)="toggleHelp()"></app-header>
    <!-- Container for rail navigation and help sidebar -->
    <mat-sidenav-container class="inner-container">
        <!-- Rail navigation -->
        <mat-sidenav #sideNav
            fixedInViewport
            role="navigation"
            mode="side"
            disableClose
            [fixedTopGap]="64"
            [opened]="true"
            *ngIf="railNavigationService.enabled">
            <app-rail-navigation></app-rail-navigation>
        </mat-sidenav> <!-- End rail navigation -->

        <!-- Main application content -->
        <mat-sidenav-content class="main-layout">
            <teller-online-notification-banner
                *ngIf="notificationBannerService.enabled"
                [ngClass]="notificationBannerService.banners[0]?.bannerClass"
                [message]="notificationBannerService.banners[0]?.message"
                [dismissAction]="notificationBannerService.banners[0]?.dismissAction"
                [resolveAction]="notificationBannerService.banners[0]?.resolveAction"
                [icon]="notificationBannerService.banners[0]?.icon"
                [svgIcon]="notificationBannerService.banners[0]?.svgIcon"
                [iconColor]="notificationBannerService.banners[0]?.iconColor"
                [svgIconClass]="notificationBannerService.banners[0]?.svgIconClass"
                [tag]="notificationBannerService.banners[0]?.tag">
            </teller-online-notification-banner>

            <main id="main-content" [ngClass]="{'debug': appService.debug}">
                <router-outlet *ngIf="!(appService.loading$ | async) && !(authService.showLoginPrompt$ | async)"></router-outlet>
                <article class="skeleton-content"></article>
            </main>
        </mat-sidenav-content> <!-- End main application content -->

        <!-- Help sidebar -->
        <mat-sidenav #helpSidenav
            id="help-sidebar"
            class="mat-sidenav--help"
            [appRestrictFocus]="helpSidenav.opened"
            fixedInViewport
            position="end"
            [fixedTopGap]="64"
            role="region"
            mode="over">
            <teller-online-help-sidebar
                [showViewAllLink]="true"
                [viewAllRoute]="'/config/help'"
                (toggleHelp)="toggleHelp()">
            </teller-online-help-sidebar>
        </mat-sidenav> <!-- End help sidebar -->
    </mat-sidenav-container> <!-- End rail navigation container -->
</div>

<teller-online-load-panel></teller-online-load-panel>
